import { Map } from 'immutable';

import { FIND, OPERATIONS, REPLACE } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';
import { VALUE } from '../../../../constants/product';

export function gtin({ channel, preview }) {
  const operation = preview.getIn([ATTRIBUTE.GTIN, 'operation']);

  return {
    payload: Map({
      type: operation,
      value: operation === OPERATIONS[channel].GTIN.FIND_AND_REPLACE
        ? Map({
          find: preview.getIn([ATTRIBUTE.GTIN, FIND]),
          replace: preview.getIn([ATTRIBUTE.GTIN, REPLACE]),
        })
        : preview.getIn([ATTRIBUTE.GTIN, VALUE]),
    }),
  };
}
